import { render } from "./PaymentSuccessView.vue?vue&type=template&id=156564a7&scoped=true"
import script from "./PaymentSuccessView.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessView.vue?vue&type=script&lang=js"

import "./PaymentSuccessView.vue?vue&type=style&index=0&id=156564a7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-156564a7"]])

export default __exports__